export const APP_CONST = {
  userStore: "user",
  apiHost: ""
};
